import { createQueryHook } from '../internal/createQueryHook';
import { followPreferences } from '../queries/followPreferences';

/**
 * @deprecated Use `followPreferences.detail` with `useQuery` directly.
 */
export const useFollowPreferences = createQueryHook(() => followPreferences.detail);
